export var STRIPE_KEY_URL = "/hamlet/1.0/public/creditCard/stripeKey";
export var PAYMENT_METHOD_TOKEN_URL = "/hamlet/1.0/public/creditCard/stripePaymentMethodToken";